// import vue
import Vue from 'vue'

// import datetimepicker
import DatetimePicker from 'vuetify-datetime-picker'
import 'vuetify-datetime-picker/src/stylus/main.styl'

Vue.use(DatetimePicker) // TODO we might be able to remove this one and only use the custom one
